import { render, staticRenderFns } from "./ZeigeKunden.vue?vue&type=template&id=a577cc18&"
import script from "./ZeigeKunden.vue?vue&type=script&lang=js&"
export * from "./ZeigeKunden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports